/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Usha        20/02/2020      2696:Facility Done Page
*********************************************************************************/
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withState } from "@mna/react";
import AnimationThankYou from "features/Animation/ThankYou";
import LoadingScreen from "features/LoadingScreen";
import { Trans } from "react-i18next";
import { careOptions, telemedicineVendors } from '../../../server/triage/constants';
import {checkAndGetLocalStorageValue } from "../../../features/utils"
import i18next from "i18next";
const redirectTo = (history, page) => {
    history.push(page);
};

const vendorListCheckAndRedirect = (state, history) => {
    var vendorArrayList = state.triageResponse.vendorsList;
    var vendorsLength = 0;
    if (vendorArrayList) {
        vendorsLength = vendorArrayList.length;
    }
    if (vendorsLength === 0) {
        redirectTo(history, "/find-care-options/telemedicine-info");
    } else if (vendorsLength >= 1) {
        var vendorSupportedModal =
            vendorArrayList[0].accessInformation.virtualAccessInformation
                .webAccessReferences[0].supportedModalities;
        state.triageRequest.supportedModalities = vendorSupportedModal.length;

        if (vendorSupportedModal.length >= 2) {
            //both option
            redirectTo(history, "/find-care-options/telemed-connectiontype");
        } else {
            if (vendorSupportedModal[0] === "Video") {
                //redirect to video prompt
                state.triageResponse.selectedConnectionType = telemedicineVendors.connectionTypeVideo; 
                redirectTo(history, "/find-care-options/telemed-videoprompt");
            } else {
                //redirect to connection page
                state.triageResponse.selectedConnectionType = telemedicineVendors.connectionTypeAudio;
                redirectTo(history, "/find-care-options/telemedicine-info");
            }
        }
    } else if (vendorsLength > 1) {
        var allVendorsArray = [];
        state.triageResponse.vendorsList.map((item) => {
            var vendors = item.nameLocalization.localizations[0].value;
            if (allVendorsArray.indexOf(vendors) === -1) {
                allVendorsArray.push(vendors);
            }
        });
        if (allVendorsArray.length >= 1) {
            var vendorSupportedModalities =
                vendorArrayList[0].accessInformation.virtualAccessInformation
                    .webAccessReferences[0].supportedModalities;

            if (vendorSupportedModalities.length >= 2) {
                //both option
                redirectTo(
                    history,
                    "/find-care-options/telemed-connectiontype"
                );
            } else {
                if (vendorSupportedModalities[0] === "Video") {
                    state.triageResponse.selectedConnectionType = telemedicineVendors.connectionTypeVideo;
                    //redirect to video prompt
                    redirectTo(
                        history,
                        "/find-care-options/telemed-videoprompt"
                    );
                } else {
                    state.triageResponse.selectedConnectionType = telemedicineVendors.connectionTypeAudio;
                    //redirect to connection page
                    redirectTo(history, "/find-care-options/telemedicine-info");
                }
            }
        } else {
            redirectTo(history, "/find-care-options/telemedicine-info");
        }
    }
};

const QuickTeleMedScreen = ({ state, setState, actions, history }) => (
    <div className="row video-prompt-container">
        <LoadingScreen isLoading={state.isLoading}>
            <div className="quick-telemed-content-width mt-3">
                <div className="standby-page-header standby-page-header-left">
                    <h1 className="telemed-page-header-title ">
                        <Trans i18nKey="findcareoption.QuickTeleMed.Available">
                            A physician is currently available to speak to
                            directly.
                        </Trans>
                    </h1>
                </div>
                <p><Trans i18nKey="findcareoption.QuickTeleMed.ConnectToDoctor">
                Skip the waiting room and connect to a licensed doctor for medical care from your phone, tablet, or computer in under 15min (on average).
                </Trans></p>
                <h1 className="telemed-page-header-title pt-0 pb-0 ">
                    <Trans i18nKey="findcareoption.QuickTeleMed.Consult">
                    Would you like to coordinate a convenient telecare consultation?
                    </Trans>
                </h1> 
                <p><Trans i18nKey="findcareoption.QuickTeleMed.ContinueTriage">If not, it's okay; we will continue with some questions to help you find an appropriate facility nearby. (approx. 5 minutes)
                </Trans></p>

                <div className="standby-col standby-center mt-4 pt-2 mb-4">
                    <AnimationThankYou />
                </div>
                <div className="quick-telemed-options">
                    <div>
                        <button
                            className="button emergency-option quick-telemed-option-true"
                            aria-label={i18next.t("findcareoption.QuickTeleMed.Consult") + " " + i18next.t("findcareoption.Yes")}
                            onClick={() => {
                                 localStorage.setItem("careoption", careOptions.Telemedicine)
                                vendorListCheckAndRedirect(state, history);
                                setState({ quickTelemedicine: true });
                                gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                            }}
                        >
                            <div className="icon icon-size-3">
                                <FontAwesomeIcon
                                    className="font-size"
                                    icon={faCheck}
                                />
                            </div>
                            <div>
                                <Trans i18nKey="findcareoption.Yes">Yes</Trans>
                            </div>
                        </button>
                    </div>
                    <div>
                        <button
                            type="button"
                            className="button emergency-option emergency-option-false"
                            aria-label={i18next.t("findcareoption.QuickTeleMed.Consult") + " " + i18next.t("findcareoption.No")}
                            onClick={() => {
                                localStorage.setItem("careoption", "");
                                actions.resetQTState(state, setState);
                                state.triageRequest.activeMenu = "symptoms";
                                history.push(`/find-care-options/symptoms`);
                                gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                            }}
                        >
                            <div className="icon icon-size-2">
                                <FontAwesomeIcon
                                    className="font-size"
                                    icon={faTimes}
                                />
                            </div>
                            <div>
                                <Trans i18nKey="findcareoption.No">No</Trans>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </LoadingScreen>
    </div>
);

export default withState({
    didMount({ state, setState }) {
        state.triageRequest.activeMenu = "care-options";
        setState({
            isLoading: false,
            UserNavigatedToQT: true,
            quickTelemedicine: true
        });
    },
})(QuickTeleMedScreen);
